import {Component, Inject, OnInit} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {MAT_DIALOG_DATA} from '@angular/material';
import {ActivatedRoute, Router} from '@angular/router';
import {MatTableDataSource} from '@angular/material/table';
import {ApplicantRequestService} from '../../service/applicant-request.service';
import {PaymentModel} from '../../model/payment.model';
import Swal from "sweetalert2";

@Component({
  selector: 'app-payment-screen',
  templateUrl: './payment-screen.component.html',
  styleUrls: ['./payment-screen.component.scss']
})
export class PaymentScreenComponent implements OnInit {
  paymentFeeForm: FormGroup;
  paymentRefNo: number;
  public PaymentModel: PaymentModel;
  public totalFee: number=0;
  public isError: boolean=false;

  constructor(private route: ActivatedRoute, private applicantRequestService: ApplicantRequestService, private router: Router) {
    this.route.paramMap.subscribe(params => {
      this.paymentRefNo = +params.get('refNo');
    });
  }

  ngOnInit() {
    this.paymentFeeForm = new FormGroup({
      paymentRefNo: new FormControl(null),
      status: new FormControl(null),
      appType: new FormControl(null),
      nic: new FormControl(null),
      appTime: new FormControl(null),
      name: new FormControl(null),
      appRefNo: new FormControl(null),
      totalAmount: new FormControl(null),
    });

    this.searchApplicant();
  }

  searchApplicant() {
    this.applicantRequestService.searchApplicant(this.paymentRefNo).subscribe(
      (result: any ) => {
        this.PaymentModel = result;
        this.paymentFeeForm.patchValue(
          {
            paymentRefNo: this.paymentRefNo,
            status: this.PaymentModel.status,
            appType: this.PaymentModel.applicationType,
            nic: this.PaymentModel.nic,
            appTime: this.PaymentModel.createdTime,
            name: this.PaymentModel.name,
            appRefNo: this.PaymentModel.appRefNo,
            totalAmount:this.PaymentModel.amount,
          }
        );
        this.calculateTotal();
      }
    );
  }

  public calculateTotal() {
    this.PaymentModel.feeList.forEach((element, index) => {
      this.totalFee = this.totalFee + element.amount;
    });
 }

  proceed() {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to proceed the payment?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes!',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.value) {
        this.applicantRequestService.proceedPayment(this.paymentRefNo).subscribe(
          (success: string) => {
            this.router.navigate(['/dashboard/payment'] );
            this.printReceipt();
        },
          (error) => {
            this.isError = true;
          },
        );
      } else {
      }
    });
    }

  printReceipt() {
    this.applicantRequestService.printPaymentReceipt(this.paymentRefNo).subscribe(
      (data: any) => {
        const file = new Blob([data], {type: 'application/pdf'});
        const fileURL = URL.createObjectURL(file);

        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = fileURL;
        document.body.appendChild(iframe);
        iframe.contentWindow.print();

      },
      error => {
        console.log(error);
      }
    );
  }

}
